import type { Message } from "@twilio/conversations";

import type { ChatMessage } from "./types";

export const normalizeMessage = (
  message: Message | ChatMessage,
): ChatMessage => ({
  sid: message.sid,
  index: message.index,
  body: message.body,
  author: message.author,
  participantSid: message.participantSid,
  attributes: message.attributes,
  dateCreated: message.dateCreated,
  aggregatedDeliveryReceipt: message.aggregatedDeliveryReceipt
    ? {
        total: message.aggregatedDeliveryReceipt.total,
        sent: message.aggregatedDeliveryReceipt.sent,
        delivered: message.aggregatedDeliveryReceipt.delivered,
        read: message.aggregatedDeliveryReceipt.read,
        undelivered: message.aggregatedDeliveryReceipt.undelivered,
        failed: message.aggregatedDeliveryReceipt.failed,
      }
    : null,
  attachedMedia: message.attachedMedia
    ? message.attachedMedia.map((media) => ({
        sid: media.sid,
        filename: media.filename,
        contentType: media.contentType,
        size: media.size,
        category: media.category,
      }))
    : null,
});
